export function compareVersion(higher: string, lower: string) {
    const sep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
    const higherAry = higher.split(sep);
    const lowerAry = lower.split(sep);
    const l = Math.max(higherAry.length, lowerAry.length);

    for (let i = 0; i < l; i++) {
        const high = parseInt(higherAry[i] || '0', 10);
        const low = parseInt(lowerAry[i] || '0', 10);

        if (high > low) {
            return 1;
        }

        if (high < low) {
            return -1;
        }
    }

    return 0;
}
